import {ERegexFlagValues, IRegexInputData} from '@relayter/rubber-duck';
import {autoserialize} from 'cerialize';

export class RegexFilterModel implements IRegexInputData {
    @autoserialize public regularExpression: string;
    @autoserialize public flags: ERegexFlagValues[];
}
